import React from "react";
import { Drawer, Box, Divider } from "@mui/material";
import SidebarHeader from "./SidebarHeader";
import SidebarMenu from "./SidebarMenu";
import ProfileSection from "./ProfileSection";
import LogoutButton from "./LogoutButton";

const Sidebar = ({ open, handleDrawerToggle, idToken }) => {
    return (
        <Drawer
            variant="permanent"
            className={`sidebar ${open ? "" : "closed"}`}
            sx={{
                width: open ? 240 : 60,
                flexShrink: 0,
                "& .MuiDrawer-paper": {
                    width: open ? 240 : 60,
                    boxSizing: "border-box",
                    transition: "width 0.3s ease",
                    backgroundColor: "#fff",
                    color: "#333",
                },
            }}
        >
            <SidebarHeader
                open={open}
                handleDrawerToggle={handleDrawerToggle}
            />
            <Divider />
            <SidebarMenu open={open} />
            <Divider />
            <Box sx={{ flexGrow: 1 }} />
            <ProfileSection open={open} />
            <LogoutButton open={open} />
        </Drawer>
    );
};

export default Sidebar;
